import { render, staticRenderFns } from "./VolunteerOnboardingModal.vue?vue&type=template&id=09c63c10&scoped=true&"
import script from "./VolunteerOnboardingModal.vue?vue&type=script&lang=js&"
export * from "./VolunteerOnboardingModal.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerOnboardingModal.vue?vue&type=style&index=0&id=09c63c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c63c10",
  null
  
)

export default component.exports